import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  assignDummyBotToTeam,
  createDummyBot,
  deleteDummyBot,
  fetchDummyBotAssignment,
  fetchDummyBots,
  reprocessDummyBotDocuments,
  fetchTeamDummyAssignment,
  unassignDummyBot,
  updateDummyBot,
} from '@/api/dummyBot'

export const fetchDummyBotsThunk = createAsyncThunk(
  'dummyBot/fetchDummyBots',
  async (roomId: string, thunkAPI) => {
    try {
      return await fetchDummyBots(roomId)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const createDummyBotThunk = createAsyncThunk(
  'dummyBot/createDummyBot',
  async (
    args: { roomId: string; payload: Parameters<typeof createDummyBot>[1] },
    thunkAPI
  ) => {
    try {
      return await createDummyBot(args.roomId, args.payload)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const updateDummyBotThunk = createAsyncThunk(
  'dummyBot/updateDummyBot',
  async (
    args: { botId: number; payload: Parameters<typeof updateDummyBot>[1] },
    thunkAPI
  ) => {
    try {
      return await updateDummyBot(args.botId, args.payload)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const deleteDummyBotThunk = createAsyncThunk(
  'dummyBot/deleteDummyBot',
  async (botId: number, thunkAPI) => {
    try {
      await deleteDummyBot(botId)
      return { botId }
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const assignDummyBotToTeamThunk = createAsyncThunk(
  'dummyBot/assignDummyBotToTeam',
  async (args: { botId: number; teamId: number }, thunkAPI) => {
    try {
      return await assignDummyBotToTeam(args.botId, args.teamId)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const unassignDummyBotThunk = createAsyncThunk(
  'dummyBot/unassignDummyBot',
  async (botId: number, thunkAPI) => {
    try {
      return await unassignDummyBot(botId)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const fetchDummyBotAssignmentThunk = createAsyncThunk(
  'dummyBot/fetchDummyBotAssignment',
  async (botId: number, thunkAPI) => {
    try {
      return await fetchDummyBotAssignment(botId)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const fetchTeamDummyAssignmentThunk = createAsyncThunk(
  'dummyBot/fetchTeamDummyAssignment',
  async (args: { roomId: string; teamId: number }, thunkAPI) => {
    try {
      return await fetchTeamDummyAssignment(args.roomId, args.teamId)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const reprocessDummyBotDocumentsThunk = createAsyncThunk(
  'dummyBot/reprocessDummyBotDocuments',
  async (args: { botId: number; documentIds?: number[] }, thunkAPI) => {
    try {
      return await reprocessDummyBotDocuments(args.botId, args.documentIds)
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)
